import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import Header from '../../../src/components/Header';
import Footer from '../../../src/components/Footer';

const NotFoundPage = () => {
    return (
        <Box
            sx={{
                bgcolor: '#141414', // Black theme
                color: 'white', // Ensure text stands out on the dark background
                minHeight: '100vh', // Full page height
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Header />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 1, // Ensures the content is centered in the available space
                    textAlign: 'center',
                    px: 4,
                    py: 12,
                }}
            >
                <Container maxWidth="sm">
                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: 'clamp(3rem, 10vw, 5rem)',
                            fontWeight: 'bold',
                            mb: 2,
                            color: '#e53935', // Accent color for the "404" text
                        }}
                    >
                        404
                    </Typography>
                    <Typography
                        variant="h5"
                        sx={{ mb: 3, color: 'rgba(255, 255, 255, 0.85)' }}
                    >
                        Oops! Page not Found.
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{ mb: 4, color: 'rgba(255, 255, 255, 0.7)' }}
                    >
                        Uh-oh! This page seems to have been phished away.
                        Don’t worry, you’re still safe here. Let’s guide you back to familiar territory.
                    </Typography>
                    <Button
                        component={Link}
                        to="/"
                        variant="contained"
                        sx={{
                            textTransform: 'none',
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            bgcolor: '#1e88e5', // Button primary color
                            '&:hover': {
                                bgcolor: '#1565c0', // Darker shade for hover
                            },
                        }}
                    >
                        Back to Home
                    </Button>
                </Container>
            </Box>
            <Footer />
        </Box>
    );
};

export default NotFoundPage;
